import { createSlice } from "@reduxjs/toolkit";
// const user = user // user will be the current user stored in the session brwser else null
//     ? { isLoggedIn: true, userFromSession }
//     : { isLoggedIn: false, user: null };

// const userFromSession = localStorage.getItem('fullname');

import DataManager from "../hooks/DataManager";

const dataManager = new DataManager()

const initialState = {
    firstName: localStorage.getItem('FirstName'),
    email: localStorage.getItem('email') || "",

    initialLogIn: false,
    verify2Factor: false,
    isLoggedIn: false,

    token: localStorage.getItem('token') || null,
    client: localStorage.getItem('client') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    userName: localStorage.getItem('userName') || null,
    userID: localStorage.getItem('userID') || null,
    companyName: localStorage.getItem('companyName') || null,
    role: localStorage.getItem('role') || null,
    DeviceUUID: localStorage.getItem('DeviceUUID') || null,
    groups: localStorage.getItem('groups') || null,
    getAllDevices: localStorage.getItem('getAllDevices') || null,

    ClickedUserID: localStorage.getItem('ClickedUserID') || null,
    ClickedUserFullName: localStorage.getItem('ClickedUserFullName') || null
}



const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        UpdateToken: (state, action) => {
            const { token, refreshToken } = action.payload;
            state.token = token;
            state.refreshToken = refreshToken;
        },
        testUpdateToken: (state, action) => {
            const { newToken } = action.payload.newApiData;
            // console.log(newRefreshToken);
            state.token = newToken;
            // state.refreshToken = newRefreshToken
        },
        Login: (state, action) => {

            const { token, client, refreshToken, Email, groups, getAllDevices } = action.payload;

            state.token = token;
            state.client = client;
            state.refreshToken = refreshToken;
            state.email = Email;
            state.groups = JSON.stringify(groups);
            state.getAllDevices = getAllDevices;
            

            localStorage.setItem('token', token);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('client', client);
            localStorage.setItem('email', Email);
            localStorage.setItem('groups', JSON.stringify(groups));
            //dataManager.setItem('groups', JSON.stringify(groups));
            //console.log(dataManager.getItem('groups'));
            
            localStorage.setItem('getAllDevices', getAllDevices);
            const expiration = new Date();
            expiration.setHours(expiration.getHours() + 1);
            localStorage.setItem('expiration', expiration.toISOString());

            state.initialLogIn = true;
        },
        twoFactorVerify: (state, action) => {

            const { userName, userID, companyName, role } = action.payload;
            state.userName = userName
            const UserIdTdInteger = parseInt(userID);


            state.userID = UserIdTdInteger;
            state.companyName = companyName
            state.role = role

            const nameParts = userName.split(' ');
            const firstName = nameParts[0];
            state.firstName = firstName;



            localStorage.setItem('userName', userName);
            localStorage.setItem('FirstName', firstName);
            localStorage.setItem('userID', UserIdTdInteger);
            localStorage.setItem('companyName', companyName);
            localStorage.setItem('role', role);
            
            dataManager.setItem('myUserID', UserIdTdInteger);

            state.verify2Factor = true;
            if (state.initialLogIn === true && state.verify2Factor === true) {
                state.isLoggedIn = true;
            }
        },
        Logout: (state) => {


            state.isLoggedIn = false;

            if (state.isLoggedIn === false) {
                state.initialLogIn = false;
                state.verify2Factor = false;

                state.token = null;
                state.refreshToken = null;
                state.client = null;
                state.userName = null;
                state.userID = null;
                state.companyName = null;
                state.role = null;
                state.email = null;

                sessionStorage.removeItem('token');
                sessionStorage.removeItem('refreshToken');
                sessionStorage.removeItem('client');
                sessionStorage.removeItem('userName');
                sessionStorage.removeItem('userID',);
                sessionStorage.removeItem('companyName');
                sessionStorage.removeItem('role');
                sessionStorage.removeItem('DeviceID');
                sessionStorage.removeItem('DeviceUUID');
                sessionStorage.removeItem('ClickedUserFullName');
                sessionStorage.removeItem('FirstName');
                sessionStorage.removeItem('DeviceName');
                sessionStorage.removeItem('email');
                sessionStorage.removeItem('ClickedUserID');
                sessionStorage.removeItem('getAllDevices');
                sessionStorage.removeItem("SavedSearchSortOrder");
                sessionStorage.removeItem("groups");
                sessionStorage.removeItem("IsGetAllDevicesPressed");
                dataManager.clearAll()

            }
        },
        authSessionCheck: (state) => {

            const token = localStorage.getItem('token');
            const refreshToken = localStorage.getItem('refreshToken');
            const client = localStorage.getItem('client');
            const userName = localStorage.getItem('userName');
            const userID = localStorage.getItem('userID');

            const initialLogInPassed = (token != null && refreshToken != null && client != null);
            const stayLoggedIn = (token != null && refreshToken != null && client != null && userName != null && userID != null);
            // When passed initial log in screen, on refresh will bring the user to the verification page.
            if (initialLogInPassed) {

                state.token = localStorage.getItem('token');
                state.refreshToken = localStorage.getItem('refreshToken');
                state.client = localStorage.getItem('client');
                state.email = localStorage.getItem('email');
                state.userID = localStorage.getItem('userID');
                state.initialLogIn = true;
            }

            // if the user had logged in and refreshes the page, they will stay signed in.
            if (stayLoggedIn) {
                state.token = localStorage.getItem('token');
                state.refreshToken = localStorage.getItem('refreshToken');
                state.client = localStorage.getItem('client');
                state.userName = localStorage.getItem('userName');
                state.firstName = localStorage.getItem('FirstName');
                state.userID = localStorage.getItem('userID');
                state.companyName = localStorage.getItem('companyName');
                state.role = localStorage.getItem('role');
                state.email = localStorage.getItem('email');

                state.isLoggedIn = true;
            } else {
                state.isLoggedIn = false;

                state.token = null;
                state.refreshToken = null;
                state.client = null;
                state.userName = null;
                state.userID = null;
                state.firstName = null;
                state.companyName = null;
                state.role = null;
                state.email = null;
            }
        },
        updateUserStatus: (state, action) => {
            state.role = action.payload;
        },
        setClickedUserDetails: (state, action) => {

            const { UserID, fullName } = action.payload

            state.ClickedUserID = UserID;
            state.ClickedUserFullName = fullName;
        },
        onBeforeRefresh: (state, action) => {
            localStorage.setItem('token', state.token);
            localStorage.setItem('refreshToken', state.refreshToken);
            localStorage.setItem('client', state.client);
            localStorage.setItem('userName', state.userName);
            localStorage.setItem('FirstName', state.firstName);
            localStorage.setItem('userID', state.userID);
            localStorage.setItem('companyName', state.companyName);
            localStorage.setItem('role', state.role);
            localStorage.setItem('email', state.email);
            localStorage.setItem('DeviceUUID', state.DeviceUUID);
            localStorage.setItem('ClickedUserID', state.ClickedUserID);


            // Remove save Search query & filters for Dashbaord Power Search before refresh
            sessionStorage.removeItem('SavedSearchQuery')
            sessionStorage.removeItem('SavedSearchFilters')
        },
        onAfterRefresh: (state, action) => {
            // state.token = localStorage.getItem('token');
            // state.refreshToken = localStorage.getItem('refreshToken');
            // state.client = localStorage.getItem('client');
            state.userName = localStorage.getItem('userName');
            state.firstName = localStorage.getItem('FirstName');
            state.userID = localStorage.getItem('userID');
            state.companyName = localStorage.getItem('companyName');
            state.role = localStorage.getItem('role');
            state.email = localStorage.getItem('email');
            state.DeviceUUID = localStorage.getItem('DeviceUUID');
            state.ClickedUserID = localStorage.getItem('ClickedUserID');

            // sessionStorage.removeItem('token');
            // sessionStorage.removeItem('refreshToken');
            // sessionStorage.removeItem('client');
            // sessionStorage.removeItem('userName');
            // sessionStorage.removeItem('FirstName');
            // sessionStorage.removeItem('userID',);
            // sessionStorage.removeItem('companyName');
            // sessionStorage.removeItem('role');
            // sessionStorage.removeItem('email');

            // sessionStorage.removeItem('DeviceID');
            // sessionStorage.removeItem('DeviceName');
            sessionStorage.removeItem('DeviceUUID');
            sessionStorage.removeItem('ClickedUserID');
        },
        updateDeviceUUID: (state, action) => {
            state.DeviceUUID = action.payload;
        }
    }
})

export const authActions = authSlice.actions;

export default authSlice.reducer;

